import { render } from "./Leads.vue?vue&type=template&id=46d0a707&scoped=true"
import script from "./Leads.vue?vue&type=script&lang=js"
export * from "./Leads.vue?vue&type=script&lang=js"

import "./Leads.vue?vue&type=style&index=0&id=46d0a707&scoped=true&lang=css"
import "./Leads.vue?vue&type=style&index=1&id=46d0a707&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46d0a707"]])

export default __exports__